module.exports = __webpack_public_path__ + "static/img/swiper2.feda13a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/swiper2.jpg
// module id = kbUD
// module chunks = 1